/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_List_View_AriaInputs */



/**
* | output |
* | --- |
* | "List view" |
*
* @param {Explorer_Display_List_View_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_list_view_aria = /** @type {((inputs?: Explorer_Display_List_View_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_List_View_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vue liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Listenansicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizzazione elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista de lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("列表视图")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リスト表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिस्ट व्यू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visualização em lista")
	return /** @type {LocalizedString} */ ("List view")
});